import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BarRow } from "./DashBits";
import WidgetExport from "./WidgetExport";

/** Dispositions tab — fully driven by the Settings dropdown catalogue. */
export default function DispositionsTab({ data, drill }) {
  const total = data.progress.total;
  return (
    <div className="space-y-4" data-testid="dash-tab-dispositions">
      <Card>
        <CardHeader className="pb-2 flex flex-row items-start justify-between">
          <div>
            <CardTitle className="text-sm">Leads by Disposition</CardTitle>
            <p className="text-[10px] text-slate-400">
              Synced with Settings → Dropdown Catalogue — new dispositions appear here automatically. Click a row to open those leads.
            </p>
          </div>
          <WidgetExport title="Dispositions" headers={["Code", "Label", "Count"]}
                        getRows={() => [...data.dispositions.map((d) => [d.code, d.label, d.count]),
                                        ["", "No disposition yet", data.no_disposition]]} />
        </CardHeader>
        <CardContent className="space-y-1.5" data-testid="dispositions-list">
          {data.dispositions.map((d) => (
            <BarRow
              key={d.code}
              label={d.label}
              count={d.count}
              total={total}
              color={d.color || "#94A3B8"}
              onClick={() => drill({ disposition: d.code })}
              testid={`dispo-row-${d.code}`}
              chip={
                <div className="w-44 flex items-center gap-1.5 min-w-0">
                  <span className="inline-block w-2 h-2 rounded-full shrink-0"
                        style={{ backgroundColor: d.color || "#94A3B8" }} />
                  <Badge variant="outline" className="text-[9px] font-mono shrink-0">{d.code}</Badge>
                  {d.label !== d.code && (
                    <span className="text-[10px] text-slate-500 truncate" title={d.label}>{d.label}</span>
                  )}
                </div>
              }
            />
          ))}
          <BarRow label="No disposition yet" count={data.no_disposition} total={total}
                  color="#E2E8F0" testid="dispo-row-none" />
        </CardContent>
      </Card>
    </div>
  );
}
